







































































































import { APICarrier } from '@/models/api/carrier.model'
import { APIProvider } from '@/models/api/provider.model'
import Snackbar from '@/models/snackbar.model'
import moment from 'moment'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class StatementForm extends Vue {
    @Prop({ required: true }) uploadFromFile!: {
        active: false;
        mode: string;
        valid: false;
        uploadfile: undefined;
        statementDate: string;
        providerId?: number;
        carrierId: number;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Prop() statementEdit!: any
    @Prop() chipFile!: boolean

    chip = false
    menu = false
    loading = false
    providers = []
    carriers = []
    close () {
        this.$emit('closeModal')
    }

    verifyEdit () {
        if (this.statementEdit.statementId && this.uploadFromFile.mode === 'Edit') {
            this.uploadFromFile.statementDate = moment(this.statementEdit.statementDate).format('YYYY-MM').toString()
            this.uploadFromFile.providerId = this.statementEdit.providerId.providerId
        }
    }

    getFileName () {
        return '.... ' + this.statementEdit.statementPath.substring(this.statementEdit.statementPath.length - 20, this.statementEdit.statementPath.length)
    }

    getMonthNow () {
        return moment().format('YYYY-MM').toString()
    }

    get userData () {
        return this.$store.state.AuthStore.auth.user
    }

    async getCarriers () {
        await this.$store.dispatch('getCarriers')
        this.carriers = this.$store.state?.CarriersStore?.carriers?.map(
                        (p: APICarrier) => {
                            return {
                                text: p.carrierName,
                                value: p.carrierId
                            }
                        }
                    )
    }

    handleOnChangeCarrier (v: number) {
        if (typeof v !== 'number') return
        this.uploadFromFile.carrierId = v
        if (this.providers.length) {
            this.uploadFromFile.providerId = undefined
        }
        this.providers = (this.$store.state.ProvidersStore?.providers || []).filter(
            (v: APIProvider & {carrierId: APICarrier}) => {
                return v.carrierId?.carrierId === this.uploadFromFile.carrierId
            }
        )
            .map((p: APIProvider) => {
                return {
                    text: p.providerName,
                    value: p.providerId
                }
            })
    }

    async getProviders () {
        await this.$store.dispatch('getProviders')
        this.providers = (this.$store.state.ProvidersStore?.providers || []).filter(
            (v: APIProvider & {carrierId: APICarrier}) => {
                return v.carrierId?.carrierId === (this.userData.carrierId?.carrierId ?? this.uploadFromFile.carrierId)
            }
        )
            .map((p: APIProvider) => {
                return {
                    text: p.providerName,
                    value: p.providerId
                }
            })
    }

    validate () {
        return (this.$refs.form as Vue & { validate: () => boolean }).validate()
    }

    save () {
        if (this.validate()) {
            if (this.uploadFromFile.mode === 'Edit') {
                this.editStatement()
            } else {
                this.createStatement()
            }
        }
    }

    /**
     * Warns the user when the statement provider has no notification emails
     * configured, so the file was saved but not delivered by email.
     */
    warnMissingNotification (resp: { data?: { notificationConfigured?: boolean } }) {
        if (resp?.data?.notificationConfigured === false) {
            this.$store.commit('addMessage', new Snackbar(
                'provider is not configure statement notification',
                'warning'
            ))
        }
    }

    createStatement () {
        this.loading = true
        this.$store.dispatch('createStatements', this.uploadFromFile)
            .then(resp => {
                if (resp.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    this.warnMissingNotification(resp)
                    this.$emit('loadData')
                    this.$emit('closeModal')
                } else {
                    this.$store.commit('reportError', 'File NOT save :(')
                }
                this.loading = false
            })
    }

    editStatement () {
        this.loading = true
        this.$store.dispatch('editStatements', { id: this.statementEdit.statementId, params: this.uploadFromFile })
            .then((resp: { status: number; data?: { notificationConfigured?: boolean } }) => {
                if (resp.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    this.warnMissingNotification(resp)
                    this.$emit('loadData')
                    this.$emit('closeModal')
                } else {
                    this.$store.commit('reportError', 'File NOT save :(')
                }
                this.loading = false
            })
    }

    async mounted () {
        this.chip = this.chipFile
        this.verifyEdit()
        await Promise.all([this.getCarriers(), this.getProviders()])
    }
}
